<div class="attachment-editor">
  @if (allowUpload) {
  <div class="upload-section">
    <app-upload-ui [allowedFiles]="allowedFiles" [allowedFilesCategoryLabel]="allowedFilesCategoryLabel"
      [maxFiles]="maxFiles" [existingFiles]="uploadUiFiles" [cloudName]="cloudName"
      [uploadPreset]="uploadPreset" uploadFieldName="Attachment"
      (filesChanged)="onUploadFilesChanged($event)">
    </app-upload-ui>
  </div>
  }

  <div class="attachments-list">
    @if (editableAttachments.length === 0) {
    <div class="empty-state">
      No attachments yet.
    </div>
    } @else {
    {{editableAttachments.length}} attachment{{ editableAttachments.length > 1 ? 's' : '' }}
    @for (att of editableAttachments; track trackByIndex; let i = $index) {
    <div class="attachment-item">
      <div class="preview">
        @if (isImage(att) && att.url) {
        <img [src]="att.url" alt="Attachment preview" />
        } @else {
        <mat-icon>attach_file</mat-icon>
        }
      </div>

      <div class="fields">
        <label>
          Title
          <input type="text" [(ngModel)]="editableAttachments[i].title" (ngModelChange)="emitCombined()" />
        </label>
        <label>
          URL
          <input type="text" [(ngModel)]="editableAttachments[i].url" (ngModelChange)="emitCombined()" />
        </label>
        <label>
          Content Type
          <input type="text" [(ngModel)]="editableAttachments[i].contentType" (ngModelChange)="emitCombined()" />
        </label>
        <label>
          Date
          <input type="date" [(ngModel)]="editableAttachments[i].creation" (ngModelChange)="emitCombined()" />
        </label>
      </div>

      <div class="actions">
        <button mat-stroked-button color="warn" type="button" (click)="removeAttachment(i)">
          Remove
        </button>
      </div>
    </div>
    }
    }
  </div>

  @if (allowManual) {
  <div class="manual-actions">
    <button mat-flat-button color="primary" type="button" (click)="addManualAttachment()">
      Add Attachment Link
    </button>
  </div>
  }
</div>